import React, {useEffect, useState, useCallback} from 'react';
import ForgotPasswordComponent from "../components/ForgotPasswordComponent";
import mainStore from "../../../stores/mainStore";
import * as mainActions from "../../../actions/actions";

const initialFormData = {
  value: '',
  valid: false,
  touched: false,
};

const initialStatus = {
  description: '',
  isError: false,
};

const ForgotPassword = () => {
  const [email, setEmail] = useState(initialFormData);
  const [status, setStatus] = useState(initialStatus);
  const [loading, setLoading] = useState(false);
  
  const showStatus = useCallback(({data}) => {
    setStatus({
      description: data.data.description,
      isError: data.data.title !== 'Done'
    });
  }, []);
  
  useEffect(() => {
    mainStore.on('changeForgotPassword', () => {
      setLoading(false);
      showStatus(mainStore.state.forgotPasswordResponse);
    });
  }, []);
  
  const onChange = (e) => {
    const {value} = e.target;
    const isEmailValid = mainStore.validateEmail(value);
    
    setEmail({
      ...email,
      value: value,
      valid: isEmailValid,
    })
  };
  
  const onBlur = (e) => {
    const isEmailValid = mainStore.validateEmail(e.target.value);
    
    setEmail({
      ...email,
      valid: isEmailValid,
      touched: true,
    });
  }
  
  const onSubmit = () => {
    setStatus(initialStatus);
    setLoading(true);
    const token = mainStore.getCookie('tm-access-token');
    mainActions.forgotPassword({email: email.value}, token);
  };
  
  return (
      <ForgotPasswordComponent
          email={email}
          onChange={(e) => onChange(e)}
          onBlur={(e) => onBlur(e)}
          onSubmit={onSubmit}
          status={status}
          loading={loading}
      />
  );
};

export default ForgotPassword;